import { Progress as ProgressPrimitive } from 'radix-ui'
import { type ElementRef, forwardRef } from 'react'
import { cn } from '@/lib/utils'
import type { ProgressProps } from './progress.types'

const Progress = forwardRef<
  ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, indicatorClassName, max = 100, value, ...props }, ref) => {
  const progress =
    value === null || value === undefined
      ? null
      : Math.min(max, Math.max(0, value))
  const percentage = progress === null ? 0 : (progress / max) * 100

  return (
    <ProgressPrimitive.Root
      ref={ref}
      value={progress}
      max={max}
      className={cn(
        'relative h-2 w-full overflow-hidden rounded-full bg-secondary',
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          'h-full w-full rounded-full bg-primary transition-transform duration-300 ease-in-out',
          indicatorClassName
        )}
        style={{ transform: `translateX(-${100 - percentage}%)` }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = 'Progress'

export { Progress }
